module.exports = __webpack_public_path__ + "static/img/宁波银行.98d3695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/宁波银行.png
// module id = Ti4m
// module chunks = 18